module.exports = __webpack_public_path__ + "static/media/ton_crystal.d6199427.svg";